module.exports = __webpack_public_path__ + "static/media/sort.039b2a2e.svg";